import React, { useEffect, useState } from 'react';
import { offerMenuFromListing, isListeningOffer, categoryForSkill, offerFromPrice, priceLabel, SKILL_FORMATS } from '../../../util/sweetSkills';
import css from './OfferMenu.module.css';
import { useHidePrices } from '../../FirstSessionFree/FirstSessionFree';

const lengthsLabel = o => Object.keys(o.durations).map(m => `${m}`).join(' / ') + ' min';
const fmtList = o => {
  const f = new Set();
  Object.values(o.durations).forEach(row => Object.keys(row).forEach(k => f.add(k)));
  return SKILL_FORMATS.filter(x => f.has(x.id)).map(x => x.label).join(', ');
};

/** One "What I offer" list. Listening is one entry next to skills; picking one swaps the booking panel below. */
export const OfferList = ({ offers, selectedId, onSelect, headingTag = 'h3' }) => {
  const H = headingTag;
  const showFree = useHidePrices();
  return (
    <div className={css.root} data-offer-menu="true">
      <H className={css.title}>What I offer</H>
      <ul className={css.list} role="listbox" aria-label="What I offer">
        {offers.map(o => {
          const listen = isListeningOffer(o);
          const cat = categoryForSkill(o.id);
          const from = offerFromPrice(o);
          const on = o.id === selectedId;
          return (
            <li key={o.id}>
              <button type="button" role="option" aria-selected={on} data-offer={o.id}
                className={[css.item, listen ? css.listen : css.skill, on ? css.on : ''].join(' ')}
                onClick={() => onSelect && onSelect(o.id)}>
                <span className={css.icon}>{listen ? '💬' : cat ? cat.emoji : '✨'}</span>
                <span className={css.main}>
                  <span className={css.label}>{listen ? 'Listening' : `Teaches ${o.label}`}</span>
                  <span className={css.meta}>{lengthsLabel(o)} · {fmtList(o)}</span>
                </span>
                <span className={css.from}>{from === 0 || (listen && showFree) ? 'Free' : `from ${priceLabel(from)}`}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

/** Booking side: offer list + one booking panel for the picked offer. */
const OfferMenu = ({ listing, initialOfferId, renderListening, renderOffer }) => {
  const offers = offerMenuFromListing(listing);
  const first = offers.some(o => o.id === initialOfferId) ? initialOfferId : (offers.find(o => isListeningOffer(o)) || offers[0])?.id;
  const [selected, setSelected] = useState(first);
  // Book from a profile offer card: follow ?offer= when it changes.
  useEffect(() => {
    if (initialOfferId && offers.some(o => o.id === initialOfferId)) setSelected(initialOfferId);
  }, [initialOfferId]); // eslint-disable-line react-hooks/exhaustive-deps
  const offer = offers.find(o => o.id === selected) || offers[0];
  return (
    <>
      {/* Separate paths (Sam, Oct 22 2026): one offer per panel, never a mixed list. Skills
          are booked from their own Book buttons (?offer=<skill>); default is Listening. */}
      {offer && isListeningOffer(offer) ? renderListening(offer) : null}
      {offer ? renderOffer(offer) : null}
    </>
  );
};
export default OfferMenu;
